import React from 'react';

import PropTypes from 'prop-types';

import './styledinput.scss';

class StyledInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      input: '',
      error: '',
      success: false,
      inTransition: false,
    };
  }

  getButtonErrorClass = () => {
    if (this.state.error) {
      return 'button--error';
    }
    return null;
  }

  getInputErrorClass = () => {
    if (this.state.error) {
      return 'input--error';
    }
    return null;
  }

  getEmailInput = () => {
    const buttonErrorClass = this.getButtonErrorClass();
    const inputErrorClass = this.getInputErrorClass();

    if (this.state.success) {
      return (
        <div className="success-container">
          <small><span style={{ fontWeight: '400' }}>{this.state.input}</span> has been added to our mailing list.</small>
          <small className="confirm-text">Not your email? <button onClick={this.resetEmail} className="skyblue success--back" role="link">Sign up with a different one.</button></small>
        </div>
      );
    }
    return (
      <div>
        <input className={inputErrorClass} id="signup" value={this.state.input} onChange={this.updateInput} type="email" placeholder={this.props.data.placeholder} />
        <button className={buttonErrorClass} type="submit">{this.props.data.cta}</button>
      </div>
    );
  }

  getFaderClass = () => {
    if (this.state.inTransition) {
      return 'input--fader';
    }
    return null;
  }

  resetEmail = () => {
    this.setState({ success: false, input: '' });
    this.cannotSubmit = false;
  }

  clearError = () => {
    this.setState({ error: '' });
  }

  postEmail = () => {
    const email = this.state.input.trim().toLowerCase();
    window.HackerAPI.Event.MailingListSignup.create(
      new window.HackerAPI.Event({ slug: 'hackthenorth2018' }),
      new window.HackerAPI.Event.MailingListSignup({ email }),
    )
      .then((data) => {
        if (data && data.email) {
          this.showSuccess();
          this.setState({ inTransition: false });
        } else {
          this.showError('Something went wrong!');
          this.setState({ inTransition: false });
          this.cannotSubmit = false;
        }
      });
  }

  showSuccess = () => {
    this.setState({ success: true });
  }

  showError = (error) => {
    this.setState({ error });
  }

  submitForm = (event) => {
    event.preventDefault();
    this.clearError();

    if (this.state.input === '' || this.cannotSubmit) {
      return;
    }

    if (!this.validateEmailAddress()) {
      this.showError('That email is invalid!');
      return;
    }

    this.cannotSubmit = true;
    this.setState({ inTransition: true });

    this.postEmail();
  }

  validateEmailAddress = () => {
    const emailPrefix = '[A-Z0-9a-z]([A-Z0-9a-z._%+-]{0,30}[A-Z0-9a-z])?';
    const emailServer = '([A-Z0-9a-z]([A-Z0-9a-z-]{0,30}[A-Z0-9a-z])?\\.){1,5}';
    const emailRegEx = `${emailPrefix}@${emailServer}[A-Za-z]{2,6}`;
    if (this.state.input.match(emailRegEx)) {
      return true;
    }
    return false;
  }


  updateInput = (event) => {
    if (event.target.value === '') {
      this.clearError();
    }
    this.setState({ input: event.target.value });
  }


  render() {
    const emailInput = this.getEmailInput();
    const faderClass = this.getFaderClass();

    return (
      <form onSubmit={this.submitForm} className="styledinput">
        <label htmlFor="signup" className="subsubtitle">
          <span className="label">{this.props.data.label}</span>
          <div className={`${faderClass} emailinput`}>
            {emailInput}
          </div>
        </label>
        <p>{this.state.error}</p>
      </form>
    );
  }
}

StyledInput.propTypes = {
  data: PropTypes.shape({
    cta: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
  }).isRequired,
};

export default StyledInput;



// WEBPACK FOOTER //
// ./src/components/StyledInput/index.jsx